// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad53a169","239":"dba21a2f","453":"9d3b3a46","732":"3a052f31"}[chunkId] + ".chunk.js";
};